/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */

let isVolumeChangeSupportedPromise;

/**
 * Does the platform support volume change (iOS doesn't for example)
 * @returns {Promise<boolean>} resolves with true if supported
 */
export function getIsVolumeChangeSupported() {
    if (!isVolumeChangeSupportedPromise) {
        let audioElt;
        isVolumeChangeSupportedPromise = Promise.race([
            new Promise(resolve => setTimeout(() => resolve(false), 1000)),
            new Promise(resolve => {
                audioElt = document.createElement('audio');
                const onVolumeChange = () => {
                    audioElt.removeEventListener('volumechange', onVolumeChange);
                    resolve(true);
                };
                audioElt.addEventListener('volumechange', onVolumeChange);
                audioElt.volume = 0.2;
            })
        ]).then(result => {
            audioElt = null;
            return result;
        });
    }
    return isVolumeChangeSupportedPromise;
}

export function clearCachedVolumeChangeSupported() {
    isVolumeChangeSupportedPromise = null;
}

/**
 * Returns a promise, which resolves once the event happens (equal to .once() , but via promises)
 * @param {{addEventListener: Function}|{once:Function}} source
 * @param {string} event
 * @returns {Promise}
 */
export const waitForEvent = (source, event) =>
    new Promise(resolve => {
        source.addEventListener(event, resolve, { once: true });
    });

export const wait = time =>
    new Promise(resolve => {
        setTimeout(resolve, time);
    });
